import React, { useState } from "react";
import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

interface PromoDropdownProps {
  selectedItem: string;
  handleSelect: (item: string) => void;
  dropdownItems: string[];
  defaultRenderValue: string;
  width: string;
}

export const PromoDropdown = ({
  selectedItem,
  handleSelect,
  dropdownItems,
  defaultRenderValue,
  width,
}: PromoDropdownProps) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const handleOpen = () => setMenuOpen(true);
  const handleClose = () => setMenuOpen(false);
  const handleChange = (event: SelectChangeEvent) => {
    handleSelect(event.target.value);
  };

  return (
    <FormControl
      sx={{
        width: width,
        minWidth: "350px !important",
        borderRadius: "8px",
      }}
    >
      <Select
        value={selectedItem}
        onChange={handleChange}
        renderValue={(value) => value || defaultRenderValue}
        displayEmpty
        onOpen={handleOpen}
        onClose={handleClose}
        open={menuOpen}
        sx={{
          fontFamily: "Roboto, sans-serif",
          fontSize: "14px",
          color: "var(--Main_icons_color)",
          backgroundColor: "#2B3544",
          borderRadius: "8px",
          maxHeight: "40px",
          height: "40px",
          "& .MuiSelect-select": {
            height: "40px",
            display: "flex",
            alignItems: "center",
            color: "var(--Main_icons_color)",
            opacity: "0.5",
          },
          "& .MuiSelect-icon": {
            color: "var(--Main_icons_color)",
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: "#2B3544",
              borderRadius: "8px",
              color: "var(--Main_icons_color)",
              fontSize: "12px !important",
              fontWeight: 500,
              overflowY: "auto",
              boxShadow: "none",
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "var(--Main_icons_color)",
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-track": {
                background: "transparent",
              },
            },
          },
        }}
      >
        {dropdownItems.map((item, i) => (
          <MenuItem
            key={i}
            value={item}
            sx={{
              fontSize: "12px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              "&:hover": {
                backgroundColor: "var(--m-background44)",
              },
              "&.Mui-selected": {
                backgroundColor: "var(--M-background98)",
              },
              "&.Mui-selected:hover": {
                backgroundColor: "var(--M-background98)",
              },
            }}
          >
            {item}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
